// import { InProgress } from "#UI";

// import React from "react";

// export default function ScoutingManagement() {
//   return (
//     <div>
//       <InProgress />
//     </div>
//   );
// }

/* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomModal,
  CustomTable,
  RowAction,
  SelectSubjectSearchBar,
} from "#components";
import ImagesUrl from "#constants/images.js";
import { TableLayout } from "#layouts";
import { AdminRoutePath } from "#routes/routePath.jsx";
import { scoutingTableHeader } from "#utils/seeds.js";
import {
  scoutingInitialValues,
  yearInitialValues,
} from "#validations/initialValues.js";
import {
  scoutingValidationSchema,
  yearValidationSchema,
} from "#validations/validationSchema.js";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import SelectSubjectList from "./scoutingPlanModal/selectSubjectList";
import ScoutingDataList from "./scoutingPlanModal/scoutingDataList";
import usePost from "#hooks/usePost.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import globalConfig from "#constants/globalConfig.js";
import useGet from "#hooks/useGet.js";
import CustomAlert from "../../components/CustomAlert";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";
import useDelete from "#hooks/useDelete.js";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Select from "react-select";
import { UseDebounce } from "#utils/helpers.js";
import ReactSelector from "../../components/ReactSelector";

const ScoutingManagement = ({ searchInputScouting }) => {
  const nav = useNavigate();
  const GrowerId = JSON.parse(
    localStorage.getItem(globalConfig.ADMIN_GROWER_ID)
  );
  const observationFileRef = useRef([]);
  const recommendationFileRef = useRef([]);
  const mixSheetInputRef = useRef(null);
  const cropStageInputRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataCount, setDataCount] = useState(10);
  const [searchInputFields, setSearchInputFields] = useState("");
  const [dataCountFieldList, setDataCountFieldList] = useState(10);
  const [currentPageFieldList, setCurrentPageFieldList] = useState(1);
  const [expandedFieldListRow, setExpandedFieldListRow] = useState(null);
  const [openModal, setOpenModal] = useState({
    add: false,
    edit: false,
  });
  const [addFieldModal, setAddFieldModal] = useState({
    add: false,
    edit: false,
  });
  const [scoutingYearModal, setScoutingYearModal] = useState({
    add: false,
    edit: false,
  });
  const [fieldDetail, setFieldDetail] = useState(null);
  const [scoutingStep, setScoutingStep] = useState(1);
  const [expandedScoutingRow, setExpandedScoutingRow] = useState(null);
  const [expandedFieldRowModal, setExpandedFieldRowModal] = useState(null);
  const [activeTab, setActiveTab] = useState("Stop Watch");
  const [time, setTime] = useState(0);
  const [localTime, setLocalTime] = useState({
    startDateTime: "",
    stopeDateTime: "",
  });
  const [isRunning, setIsRunning] = useState(false);
  const [selectedField, setSelectedField] = useState([]);
  const [selectedFieldId, setSelectedFieldId] = useState([]);
  const [selectedSubfields, setSelectedSubfields] = useState([]);
  const [scoutingDetail, setScoutingDetail] = useState(null);
  const [searchingData, setSearchingData] = useState("");
  const [expandedRow, setExpandedRow] = useState(null);
  // maul time
  const [hour, setHour] = useState("00");
  const [minute, setMinute] = useState("00");
  const [year, setYear] = useState({ label: "All", value: "" });
  const {
    mutateAsync: addScoutingMutateAsync,
    isLoading: isLoadingAddScouting,
  } = usePost(ENDPOINTS.ADD_SCOUTING, QUERY_KEYS.ADD_SCOUTING_QUERY_KEY);
  const {
    mutateAsync: editScoutingMutateAsync,
    isLoading: isLoadingEditScouting,
  } = usePost(ENDPOINTS.SCOUTING_EDIT, QUERY_KEYS.SCOUTING_EDIT_QUERY_KEY);
  const debouncedSearch = UseDebounce(searchInputScouting);
  const {
    data: scoutingListData,
    isLoading: isScoutingLoading,
    refetch: refetchScoutingList,
  } = useGet(
    ENDPOINTS.SCOUTING_LIST,
    [QUERY_KEYS.SCOUTING_LIST_QUERY_KEY, debouncedSearch],
    {
      page: currentPage.toString(),
      limit: dataCount,
      growerId: GrowerId,
      year: year?.label === "All" ? "" : year?.label,
      search: searchInputScouting,
    }
  );
  const scoutingData = scoutingListData?.data?.list;
  const { data: yearListData, isLoading: isYearLoading } = useGet(
    ENDPOINTS.SEASON_YEARS_LIST,
    QUERY_KEYS.SEASON_YEARS_LIST_QUERY_KEY,
    {
      growerId: GrowerId,
    }
  );

  const {
    mutateAsync: deleteScoutingMutateAsync,
    isLoading: isLoadingDeleteScouting,
  } = useDelete(
    ENDPOINTS.SCOUTING_DELETE,
    QUERY_KEYS.SCOUTING_DELETE_QUERY_KEY
  );

  useEffect(() => {
    refetchScoutingList();
  }, [currentPage, dataCount]);
  const {
    values: valuesYear,
    errors: errorsYear,
    touched: touchedYear,
    handleBlur: handleBlurYear,
    handleSubmit: handleSubmitYear,
    setValues: setValuesYear,
    resetForm: resetFormYear,
  } = useFormik({
    initialValues: yearInitialValues,
    validationSchema: yearValidationSchema,
    onSubmit: async (values) => {
      onOpen("add");
      handelSelectYearCloseModal("add");
    },
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: scoutingInitialValues,
    validationSchema: scoutingValidationSchema,
    onSubmit: async (values) => {
      if (openModal.add) {
        const addFormData = new FormData();
        addFormData.append("scoutingId", scoutingDetail?.scoutingId);
        addFormData.append("startTime", localTime?.startDateTime);
        addFormData.append("endTime", localTime?.stopeDateTime);
        addFormData.append("scoutTimeType", values?.scoutTimeType);
        const scoutTime =
          values?.scoutTimeType === "scoutTimeTaken"
            ? values?.scoutTime
            : values?.scoutTimeManual;

        addFormData.append("scoutTimeTaken", scoutTime || "00:00:00");

        addFormData.append("growerId", GrowerId);
        addFormData.append("fieldsDetail", JSON.stringify(selectedField));
        addFormData.append("cropStageText", values?.cropStage);
        addFormData.append("cropYear", valuesYear?.year);

        values?.cropStageFiles
          ?.map((item) => item)
          .forEach((image) => {
            addFormData.append("cropStageAttachments", image);
          });

        //Observation notes + files
        values?.observation?.forEach((item, index) => {
          addFormData.append(`observationNote[${index}]`, item.observation);
          item.observationFiles?.forEach((file, i) => {
            addFormData.append(`observationAttachments[${index}][${i}]`, file);
          });
        });

        values?.recommendation?.forEach((item, index) => {
          addFormData.append(
            `recommendationNote[${index}]`,
            item.recommendation
          );
          item.recommendationFiles?.forEach((file, i) => {
            addFormData.append(
              `recommendationAttachments[${index}][${i}]`,
              file
            );
          });
        });

        addFormData.append("sheetAttachments", values.mixSheetFile);
        try {
          const response = await addScoutingMutateAsync(addFormData);
          AlertTost(response?.message, "success");
          resetForm();
          refetchScoutingList();
          onClose("add");
        } catch (error) {
          toast.dismiss();
          AlertTost(error?.response?.data?.message, "error");
        }
      } else {
        const editFormData = new FormData();
        editFormData.append("scoutingId", scoutingDetail?._id);
        editFormData.append("startTime", localTime?.startDateTime);
        editFormData.append("endTime", localTime?.stopeDateTime);
        // editFormData.append("scoutTimeTaken", values?.scoutTime || "00:00:00");
        editFormData.append("cropStageText", values?.cropStage);
        editFormData.append("scoutTimeType", values?.scoutTimeType);
        if (values?.scoutTimeType === "scoutTimeTaken") {
          editFormData.append(
            "scoutTimeTaken",
            values?.scoutTime || "00:00:00"
          );
        } else {
          editFormData.append(
            "scoutTimeTaken",
            values?.scoutTimeManual || "00:00:00"
          );
        }

        editFormData.append(
          "cropStageAttachmentsDeleteArray",
          JSON.stringify(values?.removeCropStageFiles || [])
        );
        const removeObservationFiles =
          values.observation?.flatMap(
            (obs) => obs.removeObservationFiles || []
          ) || [];

        editFormData.append(
          "observationAttachmentsDeleteArray",
          JSON.stringify(removeObservationFiles)
        );

        const removeRecommendationFiles =
          values.recommendation?.flatMap(
            (rec) => rec.removeRecommendationFiles || []
          ) || [];

        editFormData.append(
          "recommendationAttachmentsDeleteArray",
          JSON.stringify(removeRecommendationFiles)
        );

        editFormData.append(
          "sheetAttachmentsDeleteArray",
          JSON.stringify(values?.removeMixSheetFile || [])
        );

        (values?.cropStageFiles || [])
          .filter((file) => file instanceof File)
          .forEach((file) => {
            editFormData.append("cropStageAttachments", file);
          });
        values?.observation?.forEach((item, index) => {
          editFormData.append(`observationNote[${index}]`, item.observation);

          item.observationFiles
            ?.filter((file) => file instanceof File)
            .forEach((file, i) => {
              editFormData.append(
                `observationAttachments[${index}][${i}]`,
                file
              );
            });
        });
        values?.recommendation?.forEach((item, index) => {
          editFormData.append(
            `recommendationNote[${index}]`,
            item.recommendation
          );

          item.recommendationFiles
            ?.filter((file) => file instanceof File)
            .forEach((file, i) => {
              editFormData.append(
                `recommendationAttachments[${index}][${i}]`,
                file
              );
            });
        });

        if (values?.mixSheetFile instanceof File) {
          editFormData.append("sheetAttachments", values.mixSheetFile);
        }
        editFormData.append("recommendationNoteDeleteArray", "");
        editFormData.append("observationNoteDeleteArray", "");
        try {
          const response = await editScoutingMutateAsync(editFormData);
          AlertTost(response?.message, "success");
          onClose("edit");
          resetForm();
          refetchScoutingList();
          setScoutingDetail(null);
        } catch (error) {
          toast.dismiss();
          AlertTost(error?.response?.data?.message, "error");
        }
      }
    },
  });

  const toggleScoutingRow = (index) => {
    setExpandedScoutingRow(expandedScoutingRow === index ? null : index);
  };
  const toggleFieldRowModal = (index) => {
    setExpandedFieldRowModal(expandedFieldRowModal === index ? null : index);
  };

  const toggleFieldListRow = (index) => {
    setExpandedFieldListRow(expandedFieldListRow === index ? null : index);
  };

  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };

  // Pagination functions
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((nextPage) => nextPage + 1);
  };
  // Handle count input change Filed List
  const onDataCountChangeFieldList = (e) => {
    setDataCountFieldList(e.target.value);
    setCurrentPageFieldList(1);
  };

  // Pagination functions
  const handlePrevPageFieldList = () => {
    setCurrentPageFieldList((prevPage) => prevPage - 1);
  };

  const handleNextPageFieldList = () => {
    setCurrentPageFieldList((nextPage) => nextPage + 1);
  };

  const onOpen = (key, data) => {
    setOpenModal({ ...openModal, [key]: true });
    setScoutingDetail(data);
  };
  const onClose = (key) => {
    setOpenModal({
      ...openModal,
      [key]: false,
    });
    setScoutingDetail(null);
    setOpenModal(false);
    setScoutingStep(1);
    setSelectedField([]);
    setExpandedFieldListRow(null);
    resetForm();
    stopTimer();
    setTime(0);
    setSelectedSubfields([]);
    setSelectedFieldId([]);
    setHour("00");
    setMinute("00");
    setActiveTab("Stop Watch");
    resetFormYear();
  };

  const handelFieldModal = (key, data) => {
    setAddFieldModal({ ...addFieldModal, [key]: true });
    setFieldDetail(data);
  };
  const handelFieldCloseModal = (key) => {
    setAddFieldModal({
      ...addFieldModal,
      [key]: false,
    });
    setFieldDetail(null);
  };
  const handelSelectYearModal = (key, data) => {
    setScoutingYearModal({ ...scoutingYearModal, [key]: true });
    setFieldDetail(data);
  };
  const handelSelectYearCloseModal = (key) => {
    setScoutingYearModal({
      ...scoutingYearModal,
      [key]: false,
    });
    setFieldDetail(null);
  };
  const handleObservationFileChange = (event, index) => {
    const selectedFiles = Array.from(event.target.files);
    const updatedObservation = [...values.observation];
    const prevFiles = updatedObservation[index]?.observationFiles || [];
    updatedObservation[index].observationFiles = [
      ...prevFiles,
      ...selectedFiles,
    ];
    setFieldValue("observation", updatedObservation);
  };

  const handleObservationFileClick = (index) => {
    observationFileRef.current[index].click(); // Make sure you use an array of refs
  };

  const handleObservationFileRemove = (fileIndex, file, i) => {
    const observationArray = values.observation || [];

    // Ensure the item exists
    if (!observationArray[i]) return;

    const files = observationArray[i].observationFiles || [];
    const updatedFiles = files.filter((_, index) => index !== fileIndex);

    // Update observationFiles
    setFieldValue(`observation[${i}].observationFiles`, updatedFiles);

    const removeFiles = observationArray[i].removeObservationFiles || [];
    if (typeof file === "string") {
      setFieldValue(`observation[${i}].removeObservationFiles`, [
        ...removeFiles,
        file,
      ]);
    }
  };

  // Recommendation function
  // const handleRecommendationFileChange = (event) => {
  //   const selectedFiles = Array.from(event.target.files);
  //   const prevFiles = values.recommendationFiles || [];
  //   setFieldValue("recommendationFiles", [...prevFiles, ...selectedFiles]);
  // };

  // const handleRecommendationFileClick = () => {
  //   recommendationFileRef.current.click();
  // };

  // const handleRecommendationFileRemove = (fileToRemove, url) => {
  //   const filesArray = Array.isArray(values.recommendationFiles)
  //     ? values.recommendationFiles
  //     : Array.from(values.recommendationFiles || []);
  //   const updatedFiles = filesArray.filter(
  //     (_, index) => index !== fileToRemove
  //   );
  //   setFieldValue("recommendationFiles", updatedFiles);
  //   const removeUrlArray = Array.isArray(values.removeRecommendationFiles)
  //     ? values.removeRecommendationFiles
  //     : [];
  //   if (typeof url === "string") {
  //     setFieldValue("removeRecommendationFiles", [...removeUrlArray, url]);
  //   }
  // };

  const handleRecommendationFileChange = (event, index) => {
    const selectedFiles = Array.from(event.target.files);
    const prevFiles = values.recommendation?.[index]?.recommendationFiles || [];

    const updatedRecommendation = [...values.recommendation];
    updatedRecommendation[index].recommendationFiles = [
      ...prevFiles,
      ...selectedFiles,
    ];
    setFieldValue("recommendation", updatedRecommendation);
  };
  const handleRecommendationFileClick = (index) => {
    recommendationFileRef.current[index].click();
  };
  const handleRecommendationFileRemove = (fileIndex, url, index) => {
    const recommendationArray = [...values.recommendation];
    const currentFiles = recommendationArray[index]?.recommendationFiles || [];

    recommendationArray[index].recommendationFiles = currentFiles.filter(
      (_, i) => i !== fileIndex
    );

    if (typeof url === "string") {
      const currentRemove =
        recommendationArray[index]?.removeRecommendationFiles || [];
      recommendationArray[index].removeRecommendationFiles = [
        ...currentRemove,
        url,
      ];
    }

    setFieldValue("recommendation", recommendationArray);
  };

  // mixSheetFile upload function
  const handleMixSheetFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFieldValue("mixSheetFile", file);
    }
  };

  const handelMixSheetClick = () => {
    mixSheetInputRef.current.click();
  };

  const handelMixSheetFileRemove = (url) => {
    setFieldValue("mixSheetFile", "");
    setFieldValue("removeMixSheetFile", [...values.removeMixSheetFile, url]);
  };

  const handleCropStageFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const prevFiles = values.cropStageFiles || [];
    setFieldValue("cropStageFiles", [...prevFiles, ...selectedFiles]);
  };
  const removeCropStageFile = (fileIndex, url) => {
    const filesArray = Array.isArray(values.cropStageFiles)
      ? values.cropStageFiles
      : Array.from(values.cropStageFiles || []);
    const updatedFiles = filesArray.filter((_, index) => index !== fileIndex);
    setFieldValue("cropStageFiles", updatedFiles);

    const removeUrlArray = Array.isArray(values.removeCropStageFiles)
      ? values.removeCropStageFiles
      : [];

    if (typeof url === "string") {
      setFieldValue("removeCropStageFiles", [...removeUrlArray, url]);
    }
  };

  const triggerCropStageFileInput = () => {
    cropStageInputRef.current.click();
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const startTimer = () => {
    setIsRunning(true);
    localDateTime("start");
  };

  const stopTimer = () => {
    setIsRunning(false);
    localDateTime("stop");
  };

  const localDateTime = (action) => {
    const currentDateTime = new Date();
    const year = currentDateTime.getFullYear();
    const month = String(currentDateTime.getMonth() + 1).padStart(2, "0");
    const date = String(currentDateTime.getDate()).padStart(2, "0");
    const hours = String(currentDateTime.getHours()).padStart(2, "0");
    const minutes = String(currentDateTime.getMinutes()).padStart(2, "0");
    const seconds = String(currentDateTime.getSeconds()).padStart(2, "0");

    const formattedDateTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;

    setLocalTime((prevTime) => ({
      ...prevTime,
      ...(action === "start" && { startDateTime: formattedDateTime }),
      ...(action === "stop" && { stopeDateTime: formattedDateTime }),
    }));
  };

  const handleNextStep = () => {
    if (selectedField?.length !== 0) {
      setScoutingStep(2);
    } else {
      toast.dismiss();
      toast.error("Select at least one field to next!");
    }
  };
  const onSearchChangeField = (e) => {
    setSearchInputFields(e.target.value);
  };

  const onSearchButtonClickField = (e) => {
    e.preventDefault();
    setCurrentPageFieldList(1);
    setSearchingData(searchInputFields);
  };
  useEffect(() => {
    if (searchInputFields === "") {
      setSearchingData("");
    }
  }, [searchInputFields]);

  const handleYearSelect = (selectedOption) => {
    setYear(selectedOption);
  };

  useEffect(() => {
    refetchScoutingList();
  }, [year]);
  const renderModalData = () => {
    if (scoutingStep === 1) {
      return (
        <div className="common-modal-form">
          <div className="d-flex align-items-center justify-content-center mb-2">
            <p
              className="go-to-fields"
              onClick={(e) => {
                e.preventDefault();
                handelFieldModal("add");
              }}
            >
              Go to Fields
              <img src={ImagesUrl.plusIconArrow} alt=".." />
            </p>
          </div>

          <SelectSubjectSearchBar
            searchInput={searchInputFields}
            onSearchButtonClick={onSearchButtonClickField}
            onSearchChange={onSearchChangeField}
          />
          <SelectSubjectList
            setSelectedField={setSelectedField}
            currentPage={currentPageFieldList}
            dataCount={dataCountFieldList}
            expandedRow={expandedFieldListRow}
            handleNextPage={handleNextPageFieldList}
            handlePrevPage={handlePrevPageFieldList}
            onDataCountChange={onDataCountChangeFieldList}
            toggleRow={toggleFieldListRow}
            searchInput={searchingData}
            selectedFieldId={selectedFieldId}
            selectedSubfields={selectedSubfields}
            setSelectedFieldId={setSelectedFieldId}
            setSelectedSubfields={setSelectedSubfields}
            filedModal={addFieldModal}
            seasonId={valuesYear}
          />
        </div>
      );
    } else if (scoutingStep === 2) {
      return (
        <ScoutingDataList
          cropStageFiles={values.cropStageFiles}
          cropStageInputRef={cropStageInputRef}
          handleCropStageFileChange={handleCropStageFileChange}
          removeCropStageFile={removeCropStageFile}
          handleNextPage={handleNextPage}
          handleObservationFileChange={handleObservationFileChange}
          handleObservationFileClick={handleObservationFileClick}
          handleObservationFileRemove={handleObservationFileRemove}
          handlePrevPage={handlePrevPage}
          handleRecommendationFileChange={handleRecommendationFileChange}
          handleRecommendationFileClick={handleRecommendationFileClick}
          handleRecommendationFileRemove={handleRecommendationFileRemove}
          isRunning={isRunning}
          mixSheetFile={values?.mixSheetFile}
          mixSheetInputRef={mixSheetInputRef}
          observationFile={values.observationFiles}
          observationFileRef={observationFileRef}
          onDataCountChange={onDataCountChange}
          recommendationFile={values.recommendationFiles}
          recommendationFileRef={recommendationFileRef}
          setIsRunning={setIsRunning}
          startTimer={startTimer}
          stopTimer={stopTimer}
          triggerCropStageFileInput={triggerCropStageFileInput}
          currentPage={currentPage}
          dataCount={dataCount}
          errors={errors}
          formatTime={formatTime}
          handelMixSheetClick={handelMixSheetClick}
          handleMixSheetFileChange={handleMixSheetFileChange}
          handelMixSheetFileRemove={handelMixSheetFileRemove}
          handleBlur={handleBlur}
          handleChange={handleChange}
          time={time}
          touched={touched}
          values={values}
          selectedField={selectedField}
          toggleFieldRowModal={toggleFieldRowModal}
          expandedFieldRowModal={expandedFieldRowModal}
          setFieldValue={setFieldValue}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setMinute={setMinute}
          minute={minute}
          setHour={setHour}
          hour={hour}
        />
      );
    } else {
      return null;
    }
  };

  const handelFormSubmit = () => {
    if (scoutingStep === 1) {
      handleNextStep();
    } else {
      localDateTime("stop");
      handleSubmit();
    }
  };

  const handleDeleteScouting = async (scoutingId) => {
    CustomAlert({
      title: "Are you sure you want to delete the Scouting?",
      confirmButtonText: isLoadingDeleteScouting ? (
        <ClipLoader size={17} color="#fff" />
      ) : (
        "Confirm"
      ),
      icon: "question",
      onConfirm: async () => {
        try {
          const response = await deleteScoutingMutateAsync({
            scoutingId: scoutingId,
          });
          AlertTost(response?.message, "success");
          await refetchScoutingList();
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.setTextColor(0, 102, 204); // Blue color
    doc.text("Scouting Data Report", 14, 10);
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 20);

    // Define Table Headers
    const tableColumn = ["Field Name", "Crop Name", "Area"];
    const tableRows = [];
    scoutingData?.forEach((item) => {
      item?.fieldsDetail?.forEach((field) => {
        tableRows.push([
          field?.name || "-",
          field?.cropName || "-",
          field?.area || "-",
        ]);
        if (field?.subfield) {
          field.subfield.forEach((subField) => {
            tableRows.push([
              `  → ${subField?.name || "-"}`,
              subField?.cropName || "-",
              "-",
            ]);
          });
        }
      });
    });
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 10, cellPadding: 4 },
      headStyles: { fillColor: [0, 102, 204], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 240, 240] },
    });

    // Save the PDF
    doc.save("scouting-data.pdf");
  };

  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning, setTime]);

  useEffect(() => {
    setFieldValue("scoutTime", formatTime(time));
  }, [time]);

  useEffect(() => {
    localDateTime("start");
  }, []);

  // convert get time to second
  const timeStringToSeconds = (timeString) => {
    const [hrs, mins, secs] = timeString.split(":").map(Number);
    return hrs * 3600 + mins * 60 + secs;
  };
  console.log(scoutingData, "scoutingData");

  useEffect(() => {
    if (openModal.edit) {
      setSelectedFieldId(
        scoutingDetail?.fieldsDetail?.map((field) => field._id) || []
      );
      setSelectedSubfields(
        scoutingDetail?.fieldsDetail?.flatMap(
          (field) => field.subfield?.map((sub) => sub._id) || []
        ) || []
      );
      setSelectedField(scoutingDetail?.fieldsDetail);

      setFieldValue("scoutTimeType", scoutingDetail?.scoutTimeType);
      if (scoutingDetail?.scoutTimeType === "scoutTimeTaken") {
        setTime(timeStringToSeconds(scoutingDetail?.scoutTimeTaken));
        setFieldValue(
          "scoutTime",
          scoutingDetail?.scoutTimeTaken || "00:00:00"
        );
      } else {
        setFieldValue("scoutTimeManual", scoutingDetail?.scoutTimeTaken);
        const [hh, mm] = scoutingDetail.scoutTimeTaken.split(":");
        setHour(hh || "00");
        setMinute(mm || "00");
      }
      setFieldValue("cropStage", scoutingDetail?.cropStageText);
      setFieldValue("recommendation", scoutingDetail?.recommendationNote);
      setFieldValue("observation", scoutingDetail?.observationNote);
      setFieldValue("cropStageFiles", scoutingDetail?.cropStageAttachments);
      // Observation and recommendation formatting
      const formattedObservations =
        scoutingDetail.observationAttachments?.map((obs) => ({
          observation: obs.text || "",
          observationFiles: obs.attachments || [],
          removeObservationFiles: [],
        })) || [];

      const formattedRecommendations =
        scoutingDetail.recommendationAttachments?.map((rec) => ({
          recommendation: rec.text || "",
          recommendationFiles: rec.attachments || [],
          removeRecommendationFiles: [],
        })) || [];

      setFieldValue(
        "observation",
        formattedObservations.length
          ? formattedObservations
          : [
              {
                observation: "",
                observationFiles: [],
                removeObservationFiles: [],
              },
            ]
      );

      setFieldValue(
        "recommendation",
        formattedRecommendations.length
          ? formattedRecommendations
          : [
              {
                recommendation: "",
                recommendationFiles: [],
                removeRecommendationFiles: [],
              },
            ]
      );
      setFieldValue("mixSheetFile", scoutingDetail?.sheetAttachments[0]);
      setScoutingStep(2);
      setActiveTab(
        scoutingDetail?.scoutTimeType === "scoutTimeTaken"
          ? "Stop Watch"
          : "Manual"
      );
    }
  }, [openModal.edit]);
  const multiSelectCustomStyle = {
    control: (base) => ({
      ...base,
      zIndex: 0,
      border: "1.5px solid #c9ccd0",
      padding: "9px",
      borderRadius: "10px",
      backgroundColor: "#fafafa",
      boxShadow: "none !important",
      "*": {
        boxShadow: "none !important",
      },
      "&:hover": {
        border: "1.5px solid rgb(224, 224, 224) !important",
      },
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "16px",
      color: "#a4a2a2", // Change the placeholder color
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#f8f8f8", // Change dropdown background color
      borderRadius: "8px",
      marginTop: "4px", // Adjust if needed
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // Optional: for a subtle shadow effect
    }),
    option: (base, state) => ({
      ...base,
      color: state.isSelected ? "#fff" : "#333", // Change text color for options
      backgroundColor: state.isSelected
        ? "#88BD42" // Active option background color (selected)
        : state.isFocused
        ? "#e0e0e0" // Hover effect background color
        : "#fff", // Default background color
      padding: "8px 10px",
      "&:hover": {
        backgroundColor: state.isSelected ? "#88BD42" : "#e0e0e0", // Maintain active color on hover
      },
    }),
  };

  const options = yearListData?.data.map((year) => ({
    label: year?.seasonYear,
    value: year?.seasonId,
  }));
  options?.unshift({ label: "All", value: "" });
  const scoutingYearOptions = yearListData?.data.map((year) => ({
    id: year?.seasonId,
    label: year?.seasonYear,
    value: year?.seasonId,
  }));

  return (
    <div>
      <div className="tab-pane fade show active">
        <div className="tab-content-wrapper">
          <div className="row">
            <div className="col-xl-12">
              <div className="sub-heading flex-box">
                <h2>Listing </h2>
                <div className="side-content-blk m-4">
                  <span className="fs-5"> select year</span>
                  <Select
                    options={options}
                    isLoading={isYearLoading}
                    styles={multiSelectCustomStyle}
                    value={year}
                    onChange={handleYearSelect}
                    placeholder="All"
                  />

                  {/* <div className="side-content-blk">
                    <button
                      className="primary-outline-btn"
                      onClick={exportToPDF}
                    >
                      <span className="outline_btn_icon">
                        <img
                          src="/assets/images/icons/export-csv-icon.svg"
                          alt="calc"
                        />
                      </span>
                      <span className="outline_btn_text">Export PDF</span>
                    </button>
                  </div> */}
                  {/* <button
                    className="primary-btn"
                    onClick={() => handelSelectYearModal("add")}
                  >
                    Add Scouting Plan
                  </button> */}
                </div>
              </div>
              <TableLayout
                tableHeader={scoutingTableHeader}
                isEmpty={scoutingData?.length === 0}
                isLoading={isScoutingLoading}
                currentPage={currentPage}
                totalItems={scoutingListData?.data?.totalItems}
                onDataCountChange={onDataCountChange}
                handlePrevPage={handlePrevPage}
                handleNextPage={handleNextPage}
                rowLimit={dataCount}
              >
                <CustomTable tableHeader={scoutingTableHeader}>
                  {scoutingData?.map((item, index) => {
                    const firstField = item?.fieldsDetail?.[0];
                    console.log(item, "item");

                    return firstField ? (
                      <React.Fragment key={index}>
                        <tr className="cursor-pointer position-relative">
                          <td onClick={() => toggleScoutingRow(`${index}`)}>
                            <span className="hstack gap-3">
                              {firstField?.subfield?.length > 0 ? (
                                <span
                                  className={`drop_icon ${
                                    expandedScoutingRow === `${index}`
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <img
                                    onClick={() =>
                                      toggleScoutingRow(`${index}`)
                                    }
                                    className="drop_icon"
                                    src={ImagesUrl.dopeIcon}
                                    alt="drop-icon"
                                  />
                                </span>
                              ) : (
                                <span className="drop_icon"></span>
                              )}
                              <div className="d-flex flex-wrap w-25">
                                {item?.fieldsDetail?.length > 0 ? (
                                  item.fieldsDetail.map((field, index) => (
                                    <span key={index} className="me-1">
                                      {field?.name}
                                      {index < item.fieldsDetail.length - 1 &&
                                        ", "}
                                    </span>
                                  ))
                                ) : (
                                  <span>-</span>
                                )}
                              </div>
                            </span>
                          </td>
                          {/* <td onClick={() => toggleScoutingRow(`${index}`)}>
                            {firstField?.cropName || "-"}
                          </td> */}

                          {/* <td onClick={() => toggleScoutingRow(`${index}`)}>
                            {firstField?.area || "-"}
                          </td> */}
                          <td onClick={() => toggleScoutingRow(`${index}`)}>
                            {item?.cropYear || "-"}
                          </td>
                          <RowAction
                            activeAction={{
                              edit: false,
                              view: true,
                              delete: false,
                              status: false,
                            }}
                            onEdit={() => onOpen("edit", item)}
                            onDelete={() => handleDeleteScouting(item?._id)}
                            onView={() => {
                              nav(AdminRoutePath.SCOUTING_DETAIL.path);
                              localStorage.setItem(
                                globalConfig.SCOUTING_ID,
                                JSON.stringify(item?._id)
                              );
                            }}
                          />
                        </tr>
                        {expandedScoutingRow === `${index}` &&
                          firstField?.subfield?.map((subRowData, subIndex) => (
                            <tr
                              className="cursor-pointer"
                              key={subRowData?._id || subIndex}
                            >
                              <td>{subRowData?.name || "-"}</td>
                              <td>{subRowData?.cropName || "-"}</td>
                              <td>{subRowData?.column2 || "-"}</td>
                              <td>-</td>
                            </tr>
                          ))}
                      </React.Fragment>
                    ) : null;
                  })}
                </CustomTable>
              </TableLayout>
            </div>
          </div>
        </div>
      </div>
      {/* add new scouting modal */}
      <CustomModal
        open={openModal.add || openModal.edit}
        title={
          scoutingStep === 1
            ? openModal.add
              ? "Select Field(s) (1/2)"
              : "Edit Select Field(s) (1/2)"
            : openModal.add
            ? "Enter Scouting Data (2/2)"
            : "Edit Scouting Data (2/2)"
        }
        actionButtonTitle={scoutingStep === 1 ? "Next" : "Save"}
        onClose={() => onClose(openModal.add ? "add" : "edit")}
        onSubmit={() => {
          handelFormSubmit();
        }}
        loading={isLoadingAddScouting || isLoadingEditScouting}
        saveBtnClass={scoutingStep === 1 ? "primary-btn" : "report-btn"}
        isGenerateButtonRequired={scoutingStep === 1 ? false : false}
        GenerateButtonClass="report-btn primary-outline-btn-style"
        GenerateButtonTitle="Generate Report"
        GenerateButtonAction={() => alert("work on progress")}
      >
        {renderModalData()}
      </CustomModal>
      {/* select scouting year */}
      <CustomModal
        open={scoutingYearModal.add}
        title="Select scouting year"
        actionButtonTitle="next"
        onClose={() => {
          handelSelectYearCloseModal(scoutingYearModal.add ? "add" : "edit");
          resetFormYear();
        }}
        onSubmit={() => handleSubmitYear()}
        loading={false}
      >
        <div className="common-modal-form">
          <ReactSelector
            label="Select Year"
            customClass={"col-lg-12"}
            options={scoutingYearOptions}
            placeholder="Select"
            value={{
              id: valuesYear?.seasonId,
              value: valuesYear?.seasonId,
              label: valuesYear?.year,
            }}
            isLoading={isYearLoading}
            onChange={(value) => {
              setValuesYear({
                ...valuesYear, // Keep the other values intact
                seasonId: value?.id || "",
                year: value?.label || "",
              });
            }}
            error={errorsYear?.year}
            onBlur={handleBlurYear}
            touched={touchedYear?.year}
          />
        </div>
      </CustomModal>

      {/* Add fields Modal  */}
      <CustomModal
        open={addFieldModal.add}
        title="Fields List"
        actionButtonTitle="Save"
        onClose={() =>
          handelFieldCloseModal(addFieldModal.add ? "add" : "edit")
        }
        isActionButtonRequired={false}
        loading={false}
      ></CustomModal>
    </div>
  );
};

export default ScoutingManagement;
